/**
 * Citation metadata from backend (nested in metadata field)
 */
export interface CitationMetadata {
  /** Source service identifier */
  source_service?: "google_drive" | "files_hub";
  /** Google Drive file ID */
  google_drive_file_id?: string;
  /** Google Drive web view link */
  google_drive_web_view_link?: string;
  /** Original MIME type */
  mimeType?: string;
  /** File name from metadata */
  name?: string;
  [key: string]: unknown; // Allow additional metadata fields
}

/**
 * Citation data structure from SSE message_completed events
 */
export interface Citation {
  /** Normalized label (e.g., "C1", "C2") */
  label: string;

  /** Document ID for downloading the original file */
  document_id: string;

  /** Display filename */
  filename: string;

  /** Full citation text from the document */
  text: string;

  /** Short preview snippet for display in lists */
  snippet: string;

  /** Optional evidence ID metadata */
  evidence_id?: string;

  /** Optional chunk index metadata */
  chunk_index?: number;

  /** Optional relevance score metadata */
  score?: number;

  /** Optional metadata from backend (contains Google Drive info, etc.) */
  metadata?: CitationMetadata;
}

/**
 * Helper to get Google Drive web view link from citation
 */
export function getGoogleDriveWebViewLink(citation: Citation | null): string | undefined {
  return citation?.metadata?.google_drive_web_view_link;
}

/**
 * Helper to check if citation is from Google Drive
 */
export function isGoogleDriveCitation(citation: Citation | null): boolean {
  return (
    citation?.metadata?.source_service === "google_drive" ||
    !!citation?.metadata?.google_drive_file_id ||
    !!citation?.metadata?.google_drive_web_view_link
  );
}

/**
 * Extended chat message type that includes citations
 * This extends the base ChatMessage from @webuild-ai/admin
 */
export interface ChatMessageWithCitations {
  citations?: Citation[];
}
